export default {"src":"/_next/static/media/order-packing.b2d1b74d.gif","height":1680,"width":1878,"blurWidth":0,"blurHeight":0};